<template>
    <div v-if="isLoaded">
        <div class="content-body" v-bind:class="{ fullscreen_expand: isFullscreen }">
            <div class="row match-height">
                <div class="col-xl-12 col-lg-12">
                    <div class="card" style="">
                        <div class="card-header">
                            <h4 class="card-title">Usuário</h4>
                            <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3" @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"></i></a>
                            <div class="heading-elements"  v-bind:class="{ visible: getSubMenuShowHideFw(), '': !getSubMenuShowHideFw() }">
                                <ul class="list-inline mb-0">
                                    <li><a @click="onCreateUsuario()" v-b-tooltip title="Cadastrar"><i class="ft-plus" v-if="getPermission('usuario.store')"></i></a></li>
                                    <li><a @click="onActivateDesactivate(1, null, false)" v-b-tooltip title="Ativar Registros" v-if="getPermission('usuario.status')"><i class="fa fa-thumbs-o-up"></i></a></li>
                                    <li><a @click="onActivateDesactivate(2, null, false)" v-b-tooltip title="Inativar Registros" v-if="getPermission('usuario.status')"><i class="fa fa-thumbs-o-down"></i></a></li>
                                    <li><a @click="expandFullscreen()" v-b-tooltip title="Expande a tela" v-if="!isFullscreen"><i class="ft-maximize"></i></a></li>
                                    <li><a @click="expandFullscreen()" v-b-tooltip title="Minimiza a tela" v-if="isFullscreen"><i class="ft-minimize"></i></a></li>
                                    <li><a @click="onFilterShowHide()" v-b-tooltip.hover.left="'Filtros'"><i class="fa fa-filter"></i></a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="card-content">
                            <div class="table-responsive">
                                <div v-if="vuetableFilterRow">
                                    <vuetable-filterbar>
                                    </vuetable-filterbar>
                                </div>
                                <div class="loadingDataPosition">
                                    <div class="loadingData" v-if="loadingData">
                                        <div class="loadingDataSpinner">
                                            <spinner v-if="loadingData" text-fg-color="#ffffff" message="Carregando..."></spinner>
                                        </div>
                                    </div>
                                    <vuetable ref="vuetable"
                                            api-url="/api/usuario/tela"
                                            :fields="fields"
                                            :css="css"
                                            :append-params="moreParams"
                                            track-by="usuario_id"
                                            pagination-path=""
                                            @vuetable:cell-clicked="onDetail"
                                            detail-row-component="usuario-detalhes"
                                            @vuetable:load-error="onError"
                                            @vuetable:pagination-data="onPaginationData"
                                            @vuetable:loaded="onLoaded"
                                          >
                                          <template slot="nome" slot-scope="props">
                                              <span v-if="multi_empresa==1">
                                                  {{ props.rowData.pessoa_global.pessoa_fisica_global.nome }}
                                              </span>
                                              <span v-if="multi_empresa==2">
                                                  {{ props.rowData.pessoa.pessoa_fisica.nome }}
                                              </span>
                                          </template>

                                          <template slot="status" slot-scope="props">
                                              <span class="badge badge-success" v-if="props.rowData.status.valor==1">{{ props.rowData.status.descr }}</span>
                                              <span class="badge badge-danger" v-if="props.rowData.status.valor==2">{{ props.rowData.status.descr }}</span>
                                              <span class="badge badge-secondary" v-if="props.rowData.status.valor==3">{{ props.rowData.status.descr }}</span>
                                          </template>

                                          <template slot="actions" slot-scope="props">
                                            <div class="custom-actions">
                                                <a @click="onEditUsuario(props.rowData)" v-b-tooltip title="Editar"><i class="fa fa-edit" v-if="getPermission('usuario.update')"></i></a>
                                                <span v-if="getPermission('permission.status')">
                                                    <a v-if="props.rowData.status.valor==3" @click="onActivateDesactivate(1, props.rowData, true)" v-b-tooltip title="Ativar"><i class="fa fa-thumbs-o-up"></i></a>
                                                    <a v-if="props.rowData.status.valor==2" @click="onActivateDesactivate(1, props.rowData, true)" v-b-tooltip title="Ativar"><i class="fa fa-thumbs-o-up"></i></a>
                                                    <a v-if="props.rowData.status.valor==1" @click="onActivateDesactivate(2, props.rowData, true)" v-b-tooltip title="Inativar"><i class="fa fa-thumbs-o-down"></i></a>
                                                </span>
                                                <a @click="onCreateUni(props.rowData, props.rowIndex)" v-b-tooltip title="Vincular Unidade"  v-if="getPermission('usuario.unidade.store')"><i class="fa fa-building"></i></a>
                                                <span v-if="multi_empresa==1">
                                                    <a @click="onCreateEmpresa(props.rowData, props.rowIndex)" v-b-tooltip title="Vincular Empresa"  v-if="getPermission('usuario.bcliente.store')"><i class="fa fa-building-o"></i></a>
                                                </span>
                                                <a @click="onResetSenha(props.rowData)" v-b-tooltip title="Resetar senha randômica" v-if="getPermission('usuario.senha.resetar')"><i class="fa fa-lock"></i></a>
                                                <a @click="onEditPassword(props.rowData)" v-b-tooltip title="Informar nova senha" v-if="getPermission('usuario.senha.informar')"><i class="fa fa-key"></i></a>
                                                <a @click="onCreateRole(props.rowData, props.rowIndex)" v-b-tooltip title="Vincular Role" v-if="getPermission('usuario.role.store')"><i class="fa fa-list-ol"></i></a>
                                                <a @click="onDetail(props.rowData, null, null)" v-b-tooltip title="Ver detalhes"><i class="fa fa-plus"></i></a>
                                              </button>
                                            </div>
                                          </template>
                                      </vuetable>
                                  </div>
                                <div>
                                    <div class='col-md-12'>
                                        <div class="pull-left pagination-detail">
                                            <vuetable-pagination-info ref="paginationInfo"
                                                                      :css="css.pagination"
                                                                      info-class="pull-left"
                                            ></vuetable-pagination-info>
                                        </div>
                                        <div class="pull-right m-a-0">
                                            <vuetable-pagination ref="pagination"
                                                                 :css="css.pagination"
                                                                 @vuetable-pagination:change-page="onChangePage"
                                            ></vuetable-pagination>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                  </div>
              </div>
          </div>
              <!-- Modal Component -->


               <!-- Modal Component -->
               <b-modal id="modal_form_senha"
                ref="modal_form_senha"
                :title="modal_titulo"
                :ok-title="modal_botao"
                close-title="Fechar"
                :ok-disabled=form_senha.errors.any()
                @ok="handleOkSenha">

                <form @submit.stop.prevent="handleOkSenha" @keydown="form_senha.errors.clear($event.target.senha)">
                  <label>Senha</label>
                  <b-form-input type="text"
                                placeholder="Senha"
                                v-model="form_senha.senha"
                                name="senha"
                                >
                  </b-form-input>
                  <b-form-feedback class="text-danger" v-text="form_senha.errors.get('senha')" v-if="form_senha.errors.has('senha')"></b-form-feedback>

                </form>
               </b-modal>
              <b-modal id="modal_uni"
                    ref="modal_uni"
                    :title="modal_titulo"
                    :ok-title="modal_botao"
                    close-title="Fechar"
                    v-model="showModalUni"
                    :ok-disabled=formuni.errors.any()
                    @ok="handleOkUni">
               <form @submit.stop.prevent="handleOkUni" @keydown="formuni.errors.clear($event.target.name)">
                 <label>Unidade</label>
                 <multiselect v-model="unidade"
                 :options="optionsListItemUnidade"
                 track-by="value"
                 label="label"
                 :limit="10"
                 :multiple="true"
                 :clear-on-select="false"
                 :hide-selected="true"
                 placeholder="Selecione"
                 tag-placeholder="Selecionar"
                 select-label="Selecionar"
                 selected-label="Selecionado"
                 deselect-label="Remover"
                 ></multiselect>
                 <b-form-feedback class="text-danger" v-text="formuni.errors.get('unidade_id')" v-if="formuni.errors.has('unidade_id')"></b-form-feedback>
                </form>
                   <div slot="modal-footer" class="w-100">
                       <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
                       <div class="float-right">
                           <b-btn @click="showModalUni=false" variant="secondary">
                             Fechar
                           </b-btn>
                           <b-btn @click="handleOkUni($event)" variant="secondary" :disabled="isDisabled">
                             Enviar
                           </b-btn>
                       </div>
                    </div>
                </b-modal>

                <b-modal id="modal_empresa"
                      ref="modal_empresa"
                      :title="modal_titulo"
                      :ok-title="modal_botao"
                      v-model="showModalEmpresa"
                      close-title="Fechar"
                      :ok-disabled=formbcliente.errors.any()
                      @ok="handleOkBcliente">
                 <form @submit.stop.prevent="handleOkBcliente" @keydown="formbcliente.errors.clear($event.target.name)">
                   <label>Empresa</label>
                   <multiselect v-model="formbcliente.bcliente"
                   :options="optionsListItemBcliente"
                   track-by="value"
                   label="label"
                   :limit="10"
                   :multiple="true"
                   :clear-on-select="false"
                   :hide-selected="true"
                   placeholder="Selecione"
                   tag-placeholder="Selecionar"
                   select-label="Selecionar"
                   selected-label="Selecionado"
                   deselect-label="Remover"
                   ></multiselect>
                   <b-form-feedback class="text-danger" v-text="formbcliente.errors.get('bcliente_id')" v-if="formbcliente.errors.has('bcliente_id')"></b-form-feedback>
                  </form>
                     <div slot="modal-footer" class="w-100">
                         <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
                         <div class="float-right">
                             <b-btn @click="showModalEmpresa=false" variant="secondary">
                               Fechar
                             </b-btn>
                             <b-btn @click="handleOkBcliente($event)" variant="secondary" :disabled="isDisabled">
                               Enviar
                             </b-btn>
                         </div>
                      </div>
                  </b-modal>

                <b-modal id="modal_role"
                      ref="modal_role"
                      :title="modal_titulo"
                      :ok-title="modal_botao"
                      v-model="showModalRole"
                      close-title="Fechar"
                      :ok-disabled=formuni.errors.any()
                      @ok="handleOkRole">
                 <form @submit.stop.prevent="handleOkRole" @keydown="formuni.errors.clear($event.target.name)">
                   <label>Role</label>
                   <multiselect v-model="formrole.role"
                   :options="optionsListItemRole"
                   track-by="value"
                   label="label"
                   :limit="10"
                   :multiple="true"
                   :clear-on-select="false"
                   :hide-selected="true"
                   placeholder="Selecione"
                   tag-placeholder="Selecionar"
                   select-label="Selecionar"
                   selected-label="Selecionado"
                   deselect-label="Remover"
                   ></multiselect>
                   <b-form-feedback class="text-danger" v-text="formuni.errors.get('role.value')" v-if="formuni.errors.has('role.value')"></b-form-feedback>
                  </form>
                     <div slot="modal-footer" class="w-100">
                         <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
                         <div class="float-right">
                             <b-btn @click="showModalRole=false" variant="secondary">
                               Fechar
                             </b-btn>
                             <b-btn @click="handleOkRole($event)" variant="secondary" :disabled="isDisabled">
                               Enviar
                             </b-btn>
                         </div>
                      </div>
                  </b-modal>
                  <UsuarioForm
                      ref="usuarioform" :metodo="onFilterReset" :tabela="'usuario'" :rota="'usuario'" :modal_acao="'u'">
                  </UsuarioForm>
    </div>
</div>
</template>
<script>
import Vuetable from "../components/Vuetable";
import VuetablePagination from "../components/VuetablePagination";
import VuetablePaginationInfo from "../components/VuetablePaginationInfo";
import UsuarioFilterBar from "./UsuarioFilterBar";
import moment from "moment";
import UsuarioDetalhes from "./UsuarioDetalhes";
import UsuarioForm from "./UsuarioForm";

Vue.component("usuario-detalhes", UsuarioDetalhes);

export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    UsuarioForm,
    "vuetable-filterbar": UsuarioFilterBar,
  },
  data() {
    return {
      dataExport: [],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      showModalRole: false,
      showModalEmpresa: false,
      showModalUni: false,
      isFullscreen: false,
      optionsLivStatus: [],
      optionsListItemUnidade: [],
      optionsListItemUnidadeUsuario: [],
      optionsListItemBcliente: [],
      optionsListItemBclienteUsuario: [],
      optionsListItemRole: [],
      optionsListItemRoleUsuario: [],
      optionsTpAcesso: [],
      unidade: [],
      form: new Form({
        nome: "",
        email: "",
        status: [],
        dt_ult_ace: "",
        usuario_id: "",
        bcliente: [],
        unidade: [],
        role: [],
      }),
      formuni: new Form({
        usuario_id: "",
        unidade: [],
      }),
      formbcliente: new Form({
        usuario_id: "",
        bcliente: [],
      }),
      form_senha: new Form({
        usuario_id: "",
        senha: "",
      }),
      formrole: new Form({ role: [], usuario_id: "" }),
      formDestroyRole: new Form({ role_id: "", usuario_id: "" }),
      helpForm: new Form({ statusRecord: [], params: [] }),
      fields: [
        {
          name: "__checkbox",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
        {
          name: "__slot:nome",
          title: "Nome",
          sortField: "nome",
        },
        {
          name: "email",
          title: "Email",
          sortField: "email",
        },
        {
          name: "tp_acesso.descr",
          title: "Acesso",
          sortField: "tp_acesso",
        },
        {
          name: "__slot:status",
          title: "Status",
          sortField: "status",
        },
        {
          name: "dt_ult_ace",
          title: "Data Ultimo Acesso",
          sortField: "dt_ult_ace",
          callback: "formatDateTime|DD/MM/YYYY HH:mm:ss",
        },
        {
          name: "__slot:actions",
          title: "Ações",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
      ],
      css: {
        tableClass: "table table-striped",
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  mounted() {
    this.$events.$on("filter-set", (eventData) => this.onFilterSet(eventData));
    this.$events.$on("filter-reset", (e) => this.onFilterReset());
    this.getLivGeral();
  },
  created() {
    let self = this;
    Event.$on("destroyRole", function (role_id, usuario_id) {
      self.onDestroyRole(role_id, usuario_id);
    });
    Event.$on("reloadVuetable", function (data) {
      self.onReloadVuetable();
    });
  },
  methods: {
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onFilterSet(data_filter) {
      this.loadingData = true;
      this.moreParams = {
        email: data_filter.email,
        nome: data_filter.nome,
        status: data_filter.status.value,
        unidade_id: data_filter.unidade.value,
        role_id: data_filter.role.value,
      };
      Vue.nextTick(() => {
        this.$refs.vuetable.reload();
      });
    },
    onFilterReset() {
      this.loadingData = true;
      this.moreParams = {};
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    onFilterShowHide() {
      if (this.vuetableFilterRow) {
        this.$store.commit("setVuetableFilterRow", false);
      } else {
        this.$store.commit("setVuetableFilterRow", true);
      }
    },
    onLoaded: function () {
      this.dataExport = this.$refs.vuetable.tableData;
      this.loadingData = false;
      this.$store.commit("setVuetableFilterButton", false);
    },
    onDetail(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.usuario_id);
    },
    formatDate(value, fmt = "D MMM YYYY") {
      return value == null ? "" : moment(value, "YYYY-MM-DD").format(fmt);
    },
    formatDateTime(value, fmt = "D MMM YYYY") {
      return value == null
        ? ""
        : moment(value, "YYYY-MM-DD HH:mm:ss").format(fmt);
    },
    onReloadVuetable() {
      this.$refs.vuetable.reload();
    },
    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStore();
      } else {
        this.onUpdate(this.form.usuario_id);
      }
    },
    onCreateUsuario() {
      this.$refs.usuarioform.onCreate();
    },
    onEditUsuario(data) {
      this.$refs.usuarioform.onEdit(data);
    },
    handleOkUni(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onUnidadeStore();
      } else {
        this.onUpdateUni(this.formuni.usuario_id);
      }
    },
    handleOkBcliente(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onBclienteStore();
      }
    },
    handleOkRole(e) {
      e.preventDefault();
      this.onRoleStore();
    },
    onCreateUni(data, index) {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Cadastrar";
      this.modal_botao = "Cadastrar";
      this.modal_acao = "i";
      // this.formuni.reset();
      this.formuni.unidade = [];
      this.optionsListItemUnidade = [];
      this.unidade = [];
      this.formuni.usuario_id = data.usuario_id;
      this.helpForm
        .get("/api/usuario/unidade/jsonlist/" + data.usuario_id)
        .then((response) => {
          new ReturnApi(response, this, true, false, false);
          response.unidades.forEach((obj) => {
            this.optionsListItemUnidade.push({
              label: obj.descr + " - " + obj.cd,
              value: obj.unidade_id,
            });
          });
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
      this.$refs.modal_uni.show();
    },
    onCreateEmpresa(data, index) {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Cadastrar";
      this.modal_botao = "Cadastrar";
      this.modal_acao = "i";
      // this.formuni.reset();
      this.formbcliente.usuario_id = data.usuario_id;
      this.$refs.modal_empresa.show();
    },
    onCreateRole(data, index) {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Cadastrar";
      this.modal_botao = "Cadastrar";
      this.modal_acao = "i";
      // this.formuni.reset();
      this.formrole.usuario_id = data.usuario_id;
      this.$refs.modal_role.show();
    },
    onEditUni(data, index) {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Alterar";
      this.modal_botao = "Alterar";
      this.modal_acao = "u";
      this.formuni.reset();
      this.formuni.unidade = {
        label: data.unidade.descr,
        value: data.unidade_id.valor,
      };
      this.$refs.modal_uni.show();
    },
    onStore() {
      this.loading = true;
      this.isDisabled = true;
      this.form
        .post("/api/usuario/store")
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    onBclienteStore() {
      this.loading = true;
      this.isDisabled = true;
      this.formbcliente
        .post("/api/usuario/bcliente/store")
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    onDestroyRole(role_id, usuario_id) {
      this.loading = true;
      this.isDisabled = true;
      this.formDestroyRole.role_id = role_id;
      this.formDestroyRole.usuario_id = usuario_id;
      this.formDestroyRole
        .post("/api/usuario/role/destroy")
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    onRoleStore() {
      this.loading = true;
      this.isDisabled = true;
      this.formrole
        .post("/api/usuario/role/store")
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    onUpdate(id) {
      this.loading = true;
      this.isDisabled = true;
      this.form
        .post("/api/usuario/update/" + id)
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    onActivateDesactivate(action, data, tipo) {
      // Tipo = true = Checkbox
      if (tipo) {
        this.helpForm.statusRecord = [];
        this.helpForm.statusRecord.push({
          id: data.usuario_id,
          status: action,
        });
      } else {
        this.helpForm.statusRecord = [];
        this.$refs.vuetable.selectedTo.forEach((obj) => {
          this.helpForm.statusRecord.push({ id: obj, status: action });
        });
      }

      this.helpForm
        .post("/api/usuario/status")
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    onEditPassword(data) {
      this.modal_titulo = "Alterar Senha";
      this.modal_botao = "Alterar Senha";
      this.modal_acao = "u";
      this.form_senha.reset();
      this.form_senha.usuario_id = data.usuario_id;
      this.$refs.modal_form_senha.show();
    },
    handleOkSenha() {
      this.form_senha
        .post("/api/usuario/senha/informar/" + this.form_senha.usuario_id)
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    onResetSenha(data) {
      this.form_senha
        .post("/api/usuario/senha/resetar/" + data.usuario_id)
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    onUnidadeStore() {
      this.loading = true;
      this.isDisabled = true;
      // console.log(unidade.value);
      this.unidade.forEach((obj) => {
        this.formuni.unidade.push(obj.value);
      });
      this.formuni
        .post("/api/usuario/unidade/store")
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    onUpdateUni(id) {
      this.loading = true;
      this.isDisabled = true;
      this.formuni
        .post("/api/usuario/updateuni/" + id)
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    getLivGeral() {
      this.helpForm
        .get("/api/usuario/bcliente/jsonlist")
        .then((response) => {
          new ReturnApi(response, this, true, false, false);
          response.bclientes.forEach((obj) => {
            this.optionsListItemBcliente.push({
              label: obj.cd + " - " + obj.nome,
              value: obj.bcliente_id,
            });
            this.optionsListItemBclienteUsuario.push({
              label: obj.cd + " - " + obj.nome,
              value: obj.bcliente_id,
            });
          });

          response.roles.forEach((obj) => {
            this.optionsListItemRole.push({
              label: obj.name + " - " + obj.descr,
              value: obj.id,
            });
            this.optionsListItemRoleUsuario.push({
              label: obj.name + " - " + obj.descr,
              value: obj.id,
            });
          });

          response.unidades.forEach((obj) => {
            this.optionsListItemUnidadeUsuario.push({
              label: obj.descr,
              value: obj.unidade_id,
            });
          });

          response.status_usuario.forEach((obj) => {
            this.optionsLivStatus.push({ label: obj.descr, value: obj.valor });
          });
          response.tp_acesso.forEach((obj) => {
            this.optionsTpAcesso.push({ text: obj.descr, value: obj.valor });
          });
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
    multi_empresa: {
      get() {
        return this.$store.getters.multi_empresa;
      },
    },
  },
};
</script>
